import { useQuery } from "@tanstack/react-query";
import { get2 } from "../axios";
import { getValueByAll, getValueByAllInArray } from "../utils/helpers";
import { CmsUsersResponse } from "../utils/interfaces";
import useBranchId from "./useBranchId";
import useAuthHook from "./useAuthHook";

const useAccountQuery = (customBranch?: number) => {
  const b = useBranchId();
  const branch = customBranch ?? b;
  const { isAuth } = useAuthHook();

  const query = useQuery({
    queryKey: ["account", branch],
    queryFn: () =>
      get2(`/internal/secure/pos/v1/session/cms/account/${branch}`),
    enabled: branch !== undefined && isAuth,
    select: (data) => {
      const retVal = Object.keys(data).reduce((acc, cur) => {
        acc[cur] =
          cur.includes("allowed") && Array.isArray(data[cur])
            ? getValueByAllInArray(data[cur])
            : getValueByAll(data[cur]);
        return acc;
      }, {});
      return retVal as CmsUsersResponse;
    },
    refetchOnMount: false,
  });
  return query;
};

export default useAccountQuery;
